export const basePrice = (10).toFixed(2);

export const calculateTaxRate = taxRate =>
  taxRate ? (parseFloat(basePrice) * (parseFloat(taxRate) / 100)).toFixed(2) : 0;

export const calculateTotal = (...amounts) =>
  amounts.reduce((totalTax, tax) => totalTax + parseFloat(tax), 0).toFixed(2);
